import { ReservationState } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export const reservationStatusOptions = {
    [ReservationState.Cancelled]: TextKey.ServiceOrderStateCanceled,
    [ReservationState.CheckedIn]: TextKey.CheckedIn,
    [ReservationState.ToBeCheckedOut]: TextKey.ReservationTimeStateToBeCheckedOut,
    [ReservationState.CheckOutMissed]: TextKey.ReservationTimeStateCheckOutMissed,
    [ReservationState.CheckedOutOnline]: TextKey.OnlineCheckedOut,
    [ReservationState.Past]: TextKey.ReservationTimeStatePast,
    [ReservationState.Undefined]: TextKey.LedgersReservationStatusNull,
};
